module.exports = __webpack_public_path__ + "static/media/agronomySpread.9e6bfe8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/Result/images/agronomySpread.svg
// module id = 861
// module chunks = 0